import React from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Device } from '../../../../../../../../types/Device';

interface DeleteDeviceModalProps {
    visible: boolean;
    device: Device | null;
    onOk: () => void;
    onCancel: () => void;
}
const DeleteDeviceModal: React.FC<DeleteDeviceModalProps> = ({
    visible,
    device,
    onOk,
    onCancel,
}) => {
    return (
        <Modal
            title={
                <div className="titleModal_delDevOne">
                    <span className="spanGroup_delDevOne">Удаление устройства</span>
                    <>
                        <CloseOutlined onClick={onCancel} className="closeBut_Group" />
                    </>
                </div>
            }
            className="add-device-modal"
            visible={visible}
            onOk={onOk}
            onCancel={onCancel}
            width={720}
            closable={false}
            footer={[
                <Button
                    key="cancel"
                    className="button-base button-type-secondary button-size-medium"
                    onClick={onCancel}
                >
                    Нет
                </Button>,
                <Button
                    key="ok"
                    className="button-base button-type-primary button-size-medium"
                    onClick={onOk}
                >
                    Да
                </Button>,
            ]}
        >
            <span className="contentText">
                Удалить "Устройство {device?.name}" из текущей раскладки??{' '}
            </span>
        </Modal>
    );
};
export default DeleteDeviceModal;
